import { render, staticRenderFns } from "./SearchContactsModal.vue?vue&type=template&id=08af7028"
import script from "./SearchContactsModal.vue?vue&type=script&lang=js"
export * from "./SearchContactsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports